import { MenuSettingsConfiguration, SettingsDataValues } from './types';

export const parseSettingsDataValues = (
    data: SettingsDataValues,
    settingsConfig: MenuSettingsConfiguration[],
): SettingsDataValues => {
    const parsed = { ...data };
    settingsConfig.forEach(({ id, settings }) => {
        if (!parsed[id]) {
            parsed[id] = {};
        }
        parsed[id] = { ...data[id] };

        settings.forEach((setting) => {
            if (typeof parsed[id][setting.name] !== setting.type) {
                parsed[id][setting.name] = setting.defaultValue;
            }
        });
    });
    return parsed;
};
